import React from 'react';
import ReactDOM from 'react-dom';
import { PrimaryButton } from '../PrimaryButton/PrimaryButton';
import { DialogContainer, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogActions } from './DialogOptionBox.styles';

export interface DialogOptionBoxProps {
  title: string;
  description: string;
  primaryButtonText: string;
  secondaryButtonText?: string;
  onPrimaryClick: () => void;
  onSecondaryClick?: () => void;
  isOpen: boolean;
}

const DialogOptionBox: React.FC<DialogOptionBoxProps> = ({
  title,
  description,
  primaryButtonText,
  secondaryButtonText,
  onPrimaryClick,
  onSecondaryClick,
  isOpen
}) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <DialogContainer>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogActions>
          <PrimaryButton onClick={onPrimaryClick}>
            {primaryButtonText}
          </PrimaryButton>
          {secondaryButtonText && onSecondaryClick && (
            <PrimaryButton variant="outline" onClick={onSecondaryClick}>
              {secondaryButtonText}
            </PrimaryButton>
          )}
        </DialogActions>
      </DialogContent>
    </DialogContainer>,
    document.body
  );
};

export default DialogOptionBox;
